import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import moment from 'moment'

export default function Weekday ({ name, ...forwardProps }) {
  const rawDate = useValue(name)

  if (!rawDate) {
    return null
  }

  const date = moment(rawDate)

  return date.format('ddd DD. MMM. YYYY')
}
